export class AxiosHeaders {
}
AxiosHeaders.headers = {};
